import MapBox from './../modules/map'
import { CityPoupComponent } from './../components/CityPopup/CityPopup'
import { DetailsPanel } from '../sections/luxury-yachting/components/DetailsPanel/DetailsPanel'
import { EventDetailsPanel } from './../components/EventDetailsPanel/EventDetailsPanel'

export class PortsModule {
  ports = []
  showPorts = true

  constructor() { }

  initialize(ports) {
    this.ports = ports.map(port => {
      let portData = {
        ['id']: port.id,
        ['longitude']: port.position.longitude,
        ['latitude']: port.position.latitude,
        ['ISO_3166_1_ALPHA_2']: port.ratings.isoCode2,
        ['ISO_3166_1_ALPHA_3']: port.ratings.isoCode3,
        ['cityName']: port.ratings.cityname,
        ['portName']: port.name,
        ['countryName']: port.ratings.country,
        ['cityRating']: port.ratings.cityRating,
        ['portRating']: port?.riskLevel?.id || 0,
        ['countryRating']: port.ratings.countryRating,
        ['countryMedicalRating']: port.ratings.countryMedical,
        ['ISPSSecurityRating']: port.ispsSecurityLevel.description,
        ['portRiskAssessmentLevel']: port.pal,
        ['portCode']: port.unlocode
      }
      return portData
    })
    this.display()
    this.initializeEventListeners()
  }


  getFeatureCollection(ports) {
    var featureCollection = {
      type: 'FeatureCollection',
      features: []
    }

    for (var port of ports) {
      var point = {
        type: 'Point',
        coordinates: [port.longitude, port.latitude]
      }

      var feature = {
        type: 'Feature',
        id: port.id,
        geometry: point,
        properties: port
      }

      featureCollection.features.push(feature)
    }

    return featureCollection
  }

  display() {
    const portsFeatureCollection = this.getFeatureCollection(this.ports)

    const cityLayers = MapBox.map.getSource('ports')
    if (cityLayers !== undefined) {
      cityLayers.setData(portsFeatureCollection)
    } else {

      MapBox.map.addSource('ports', {
        'type': 'geojson',
        'data': portsFeatureCollection
      })

      MapBox.map.addLayer({
        id: 'ports',
        type: 'symbol',
        source: 'ports',
        paint: {
          'text-color': '#ffffff',
          'text-halo-width': 1,
          'text-halo-color': '#000000'
        },
        layout: {
          'visibility': this.showPorts ? 'visible' : 'none',
          'icon-image': 'port-risk-0',
          'icon-allow-overlap': true,
          'text-allow-overlap': false,
          'icon-size': .7,
          'text-size': ['interpolate', ['linear'], ['zoom'], 0, 6, 3.5, 8, 4.5, 10, 7, 12],
          'text-field': ['get', 'portName'],
          'text-font': [
            'Open Sans Semibold',
            'Arial Unicode MS Bold'
          ],
          'text-offset': [0, 1],
          'text-anchor': 'top'
        }
      })
      this.updatePortRiskIcons()
    }
  }

  updatePortRiskIcons() {
    MapBox.map.setLayoutProperty('ports', 'icon-image', 'port-risk-0')
  }

  getPorts() {
    return this.ports
  }

  show() {
    this.showPorts = true
    MapBox.map.setLayoutProperty('ports', 'visibility', 'visible')
  }

  hide() {
    this.showPorts = false
    MapBox.map.setLayoutProperty('ports', 'visibility', 'none')
  }

  showPortSelected(port) {
    const data = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          id: port.id,
          geometry: {
            type: 'Point',
            coordinates: [port.longitude, port.latitude]
          }
        }
      ]
    }
    let portsSource = MapBox.map.getSource('portsSelected')
    if (portsSource === undefined) {
      MapBox.map.addSource('portsSelected', {
        'type': 'geojson',
        'data': data
      })
      MapBox.map.addLayer({
        id: 'portsSelected',
        type: 'symbol',
        source: 'ports',
        paint: {
          'text-color': '#ffffff',
          'text-halo-width': 1,
          'text-halo-color': '#000000'
        },
        layout: {
          'visibility': 'none',
          'icon-image': 'port-highlight-0',
          "icon-size": ['interpolate', ['linear'], ['zoom'], 3.5, 0.415, 4.5, 0.5, 7, 0.6],
          'text-size': ['interpolate', ['linear'], ['zoom'], 0, 6, 3.5, 8, 4.5, 10, 7, 12],
          'text-field': ['get', 'portName'],
          'text-font': [
            'Open Sans Semibold',
            'Arial Unicode MS Bold'
          ],
          'text-offset': [0, 1],
          'text-anchor': 'top'
        }
      })
      MapBox.map.setFilter('portsSelected', ['==', 'id', port.id])
      MapBox.map.setLayoutProperty('portsSelected', 'visibility', 'visible')
    } else {
      MapBox.map.setFilter('portsSelected', ['==', 'id', port.id])
      MapBox.map.setLayoutProperty('portsSelected', 'visibility', 'visible')
      portsSource.setData(data)
    }

    if (port.longitude, port.latitude) {
      MapBox.map.flyTo({ center: ['' + port.longitude, '' + port.latitude], zoom: 8 })
    }
    this.updatePortRiskSelectionIcons()
  }

  updatePortRiskSelectionIcons() {
    MapBox.map.setLayoutProperty('portsSelected', 'icon-image', 'port-highlight-0')
  }

  hidePortSelected(portId) {
    if (!MapBox.map.getLayer('portsSelected')) return
    MapBox.map.setFilter('portsSelected', ['==', 'id', portId])
    MapBox.map.setLayoutProperty('portsSelected', 'visibility', 'none')
  }

  showPort(portData) {
    // Open city panel with port data (port tab was removed; port click opens city view)
    if (EventDetailsPanel.isPanelOpen) {
      EventDetailsPanel.hidePanel()

      const timeout = window.setTimeout(() => {
        DetailsPanel.showDetailsPanel(portData, 'city')
        window.clearTimeout(timeout)
      }, 500)
    } else {
      DetailsPanel.showDetailsPanel(portData, 'city')
    }
    setTimeout(() => {
      this.showPortSelected(portData)
    }, 200)
  }

  initializeEventListeners() {
    MapBox.map.on('mouseenter', 'ports', (e) => {
      CityPoupComponent.$data.display = 'block'
      CityPoupComponent.$data.opacity = 1

      var portData = e.features[0].properties

      CityPoupComponent.$data.isPort = true
      CityPoupComponent.$data.port = portData.portName
      CityPoupComponent.$data.city = portData.cityName
      CityPoupComponent.$data.country = portData.countryName
      CityPoupComponent.$data.portRating = portData.portRating
      CityPoupComponent.$data.cityRating = portData.cityRating
      CityPoupComponent.$data.countryRating = portData.countryRating

      // Change the cursor style as a UI indicator
      MapBox.map.getCanvas().style.cursor = 'pointer'
    })

    MapBox.map.on('mouseleave', 'ports', () => {
      CityPoupComponent.$data.isPort = false
      CityPoupComponent.$data.display = 'none'
      CityPoupComponent.$data.opacity = 0
      MapBox.map.getCanvas().style.cursor = 'inherit'
    })

    MapBox.map.on('mousemove', 'ports', (e) => {
      CityPoupComponent.$data.leftPosition = e.point.x + 15 + 'px'
      CityPoupComponent.$data.topPosition = e.point.y + 15 + 'px'
    })
  }
}

const Ports = new PortsModule()
export default Ports